import invoiceFleetService from "@/services/mrfiktiv/services/fleet/invoiceFleetService";
import {
  MrfiktivInvoicePopulatedViewModelGen,
  MrfiktivInvoiceViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

@Module({
  dynamic: true,
  namespaced: true,
  name: "invoiceFleetStore",
  store
})
export class InvoiceFleetStore extends VuexModule {
  _current: MrfiktivInvoicePopulatedViewModelGen | null = null;
  _all: MrfiktivInvoiceViewModelGen[] = [];

  get all(): MrfiktivInvoiceViewModelGen[] {
    return this._all;
  }

  get current() {
    return this._current;
  }

  @Mutation
  _mutateCurrent(data: MrfiktivInvoicePopulatedViewModelGen) {
    this._current = data;
  }

  @Action
  setCurrent(data: MrfiktivInvoiceViewModelGen) {
    this.context.commit("_mutateCurrent", data);
  }

  @Mutation
  private _mutateAll(request: MrfiktivInvoiceViewModelGen[]) {
    this._all = request;
  }

  @Mutation
  private _mutateOne(request: MrfiktivInvoiceViewModelGen) {
    const index = this.all.findIndex(item => item.id === request.id);

    if (index !== -1) {
      this._all.splice(index, 1, request);
    } else {
      this._all.push(request);
    }
  }

  @Action
  async getAll(data: { partnerId: string; fleetId: string }): Promise<MrfiktivInvoiceViewModelGen[]> {
    const response = await invoiceFleetService.findAll(data.partnerId, data.fleetId);

    this.context.commit("_mutateAll", response.data.data);

    // FIXME: Add pagination logic
    return response.data.data ?? [];
  }

  @Action
  async getOne(data: {
    partnerId: string;
    fleetId: string;
    id: string;
  }): Promise<MrfiktivInvoicePopulatedViewModelGen> {
    const response = await invoiceFleetService.findOne(data.partnerId, data.fleetId, data.id);

    this.context.commit("_mutateOne", response.data);
    this.context.commit("_mutateCurrent", response.data);

    return response.data;
  }
}

export const InvoiceFleetModule = getModule(InvoiceFleetStore);
